/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Promo_Movement_Received_By_SelfInputs */



/**
* | output |
* | --- |
* | "Yourself ({name}) — pick a member to record a batch they received." |
*
* @param {Promo_Movement_Received_By_SelfInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_received_by_self = /** @type {((inputs: Promo_Movement_Received_By_SelfInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Received_By_SelfInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous-même (${i?.name}) — choisissez un membre pour enregistrer un lot que ce membre a reçu.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Usted mismo (${i?.name}) — elija un miembro para registrar un lote que ese miembro recibió.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Você mesmo (${i?.name}) — escolha um membro para registrar um lote que esse membro recebeu.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tu stesso (${i?.name}) — scegli un membro per registrare un lotto che quel membro ha ricevuto.`)
	return /** @type {LocalizedString} */ (`Yourself (${i?.name}) — pick a member to record a batch they received.`)
});